"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRatioObjectBy = getRatioObjectBy;
exports.getRatioName = getRatioName;
const RATIO_MAP = {
  WIDE: {
    ratio: '16:9',
    height: 720.00,
    width: 1280.00,
    name: 'wide',
    x: 0
  },
  SQUARE: {
    ratio: '1:1',
    height: 720.00,
    width: 720.00,
    name: 'square',
    x: 280
  },
  VERTICAL: {
    ratio: '9:16',
    height: 1280.00,
    width: 720.00,
    name: 'vertical',
    x: 437.5
  }
};

function getRatioObjectBy(attr, value) {
  return _.find(RATIO_MAP, {
    [attr]: value
  });
}

function getRatioName(ratio) {
  return getRatioObjectBy('ratio', ratio).name;
}